import React, { FC } from "react";
import { Button, Form, Input } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import MainCreationForm from "components/forms/MainCreationForm";

import { OrganizationFormProps, OrganizationFormValues } from "./types";

const OrganizationForm: FC<OrganizationFormProps> = ({
  submitHandler,
  loading,
  initialValues,
  isReadOnly,
  form,
  onValuesChange,
}) => {
  const intl = useIntl();

  const onFinish = (values: OrganizationFormValues) => {
    submitHandler?.(values);
  };

  return (
    <MainCreationForm
      name="organizationForm"
      autoComplete="off"
      disabled={loading}
      onFinish={onFinish}
      $isReadOnly={isReadOnly}
      {...{ form, onValuesChange, initialValues }}
    >
      <Form.Item
        label={intl.formatMessage({
          defaultMessage: "Organization name",
        })}
        name={["input", "name"]}
        required
      >
        <Input readOnly={isReadOnly} />
      </Form.Item>
      {!isReadOnly && (
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            <FormattedMessage defaultMessage="Submit" />
          </Button>
        </Form.Item>
      )}
    </MainCreationForm>
  );
};

export default OrganizationForm;
